import { createFileRoute, redirect } from '@tanstack/react-router';

import {
  canAccess,
  isUsersAdminRoute,
  Permission,
  resolveDefaultAppPath,
  shouldDeferRouteGuard,
} from '@auth/data-access';

export const Route = createFileRoute('/_app/_admin')({
  beforeLoad(ctx) {
    const { auth } = ctx.context;

    if (shouldDeferRouteGuard(auth)) {
      return;
    }

    const role = auth.user?.user_access;

    if (
      isUsersAdminRoute(ctx.location.pathname) &&
      canAccess(role, Permission.Users)
    ) {
      return;
    }

    if (!canAccess(role, Permission.AccessAdminRoutes)) {
      throw redirect({
        to: resolveDefaultAppPath(auth.user),
      });
    }
  },
});
